module.exports = __webpack_public_path__ + "img/girl.412beb8d.svg";